export function drainFrames(buffer, onFrame) {
  let rest = buffer.replace(/\r\n/g, '\n')
  let index = rest.indexOf('\n\n')
  while (index !== -1) {
    const rawFrame = rest.slice(0, index)
    rest = rest.slice(index + 2)
    if (rawFrame.trim()) emitFrame(rawFrame, onFrame)
    index = rest.indexOf('\n\n')
  }
  return rest
}

export function emitFrame(rawFrame, onFrame) {
  let event
  const dataLines = []

  for (const line of rawFrame.split('\n')) {
    if (!line || line.startsWith(':')) continue
    if (line.startsWith('event:')) {
      event = line.slice(6).trim()
    } else if (line.startsWith('data:')) {
      dataLines.push(line.slice(5).replace(/^ /, ''))
    }
  }

  if (event === undefined && dataLines.length === 0) return
  onFrame({ event, data: dataLines.join('\n') })
}

export function parseFrameData(data) {
  const trimmed = data.trim()
  if (!trimmed || trimmed === '[DONE]') return null
  try {
    return JSON.parse(trimmed)
  } catch {
    return null
  }
}
